import moment from "moment-timezone";
import {mapState} from "vuex";
import {servelService} from "@/api/servelApi";

export const FechaMaximaReclamacionMixin = {
  data() {
    return {
      plazomaximoapelacion: 10,
      model: {
        fechaMaxima: moment()
          .add(14, "days"),
      }
    }
  },
  computed: {
    ...mapState({
      parametro: (state) => state.parametro,
    }),
  },
  methods: {
    fechaMaximaReclamacion() {
      if (this.parametro.params) {
        this.plazomaximoapelacion = parseInt(this.parametro.params.plazomaximoapelacion)
      }

      const bodyFecha = {
        date: moment().locale("es").format("YYYY-MM-DD"),
        region: null,
        output_format: "DD-MM-YYYY",
        days: this.plazomaximoapelacion,
      };

      return new Promise((resolve, reject) => {
        servelService.getFechaMaximaReclamacion(bodyFecha)
          .then((response) => {
            this.$log.debug('getFechaMaximaReclamacion', response.data)
            this.model.fechaMaxima = moment(response.data.date, "DD-MM-YYYY").format("DD-MM-YYYY")
            resolve()
          })
          .catch((err) => {
            this.$log.fatal('getFechaMaximaReclamacion', err, err.response, err.request)
            this.showError(
              "Ocurrión un problema al cargar la fecha máxima de Reclamación"
            );
            reject(err)
          });
      })
    },
  }
}
